import React, {useEffect} from "react";
import {FieldTable} from "../../../components/FieldTable/FieldTable";
import {variableCurrencyValue} from "../../../components/field-table";
import {MediaType} from "../../../generated/graphql";
import {FieldTableColumnProps} from "../../../components/FieldTable/FieldTableTypes";
import {PosterSizeSelect} from "../../../components/MaterialSelects/PosterSizeSelect";
import {MediaTypeSelect} from "../../../components/MaterialSelects/MediaTypeSelect";
import {useOutletContext} from "react-router-dom";
import {CampaignOutletContextValue} from "../form";

function newRow() {
    return {
        campaignComponent: {
            unit_value_local: 0,
            qty: 0,
            price_divisor: 1
        },
        size: null,
        mediaType: null,
        notes: ''
    };
}


const summaries = {
    footer: (old, newRow) => {
        return !newRow;
    }
}

const MediaProductionPane = () => {
    const {
        values,
        setValue,
        loading,
        errors,
        readOnly,
        setTab,
        isReadOnly
    } = useOutletContext<CampaignOutletContextValue>();
    const columns: FieldTableColumnProps<MediaType>[] = [
        {
            header: 'Media Type',
            accessor: 'mediaType',
            sort: 'mediaType.name',
            dataType: 'select',
            options: {
                label: 'label',
                renderEditor: ({field}) => <MediaTypeSelect {...field} autoFocus={true}/>
            }
        },
        {
            header: 'Size',
            accessor: 'size',
            sort: 'size.customer_name',
            dataType: 'select',
            options: {
                label: 'customer_name',
                renderEditor: ({field}) => <PosterSizeSelect saveFields={['id','customer_name','name','trashed','__typename']} showCustomerName={true} isMediaType={true} {...field}
                                                             autoFocus={true}/>
            }
        }, {
            header: 'Unit Value',
            accessor: 'campaignComponent.unit_value_local',
            sort: 'campaignComponent.unit_value_local',
            dataType: 'currency',
            readOnly: () => {
                return isReadOnly(true)
            },
            options: {
                currency: {
                    accessor: 'campaignComponent.currency',
                    divisorAccessor: 'campaignComponent.price_divisor',
                    allowContextCurrency:true
                },
                /*            getValue:({field})=>{
                                console.log('PDIV GET ',field.value);
                                if(!field.value) return '';
                                const uv = parseInt(field.value.unit_value_local?field.value.unit_value_local:0);
                                const pd = parseInt(field.value.price_divisor?field.value.price_divisor:1);
                                console.log('PDIV RETURN ',asMoney2(uv,String(pd).length+1));
                                return asMoney2(uv,String(pd).length+1);
                //                return ''+variableCurrencyValue({currency:null,value:uv,places:});
                            },*/
                /*
                onChange:(event,props)=>{
                    const target = event.currentTarget??event.target;
                    const parts = target.value.toString().split('.');
                    let divisor = 1;
                    let value = '';
                    if(parts.length) {
                        if(!parts[1]) { parts[1] = ''; }
                        value = parts[0]+parts[1]+'00';
                        divisor = Math.pow(10,parts[1].length);
                    }
                    let intValue = parseInt(value,10);
                    while(intValue && (intValue%10==0) && divisor>=10) {
                        intValue = intValue/10;
                        divisor = divisor/10;
                    }
                    console.log('PDIV SET VALUE',{target:target.value,rawInt:parseInt(value),raw:value,pd:divisor,value:intValue});
                    props.field.setValue(props.rowName+'.campaignComponent.price_divisor',divisor);
                    props.field.setValue(props.rowName+'.campaignComponent.unit_value_local',intValue);
                },*/
                /*            renderEditor: ({field,row,rowName}) => {
                                var uv = parseInt(field.value.unit_value_local?field.value.unit_value_local:0);
                                var pd = parseInt(field.value.price_divisor?field.value.price_divisor:1);
                                var value:any  = '';
                                if(field.value.unit_value_local==='') {
                                    value = '';
                                } else {
                                    value = asMoney2(uv,String(pd).length+1); // -1 from length, +2 from £ offset
                                }
                                const setValue=(evt)=>{
                                    var parts = evt.target.value.toString().split('.');
                                    if(!parts.length) {
                                        value = '';
                                        var divisor = 1;
                                    } else {
                                        if(!parts[1]) { parts[1] = ''; }
                                        value = parts[0]+parts[1]+'00';
                                        divisor = Math.pow(10,parts[1].length);
                                    }
                                    value = parseInt(value);
                                    while(value && (value%10==0) && divisor>=10) {
                                        value = value/10;
                                        divisor = divisor/10;
                                    }
                                    //console.log('PDIV SET VALUE',{pd:divisor,value:value});
                                    field.setValue(rowName+'.campaignComponent.price_divisor',divisor);
                                    field.setValue(rowName+'.campaignComponent.unit_value_local',value);
                                };
                                return <NumberInput name="" className="" {...field} value={value} onChange={setValue} autoFocus={true}/>;
                            }*/
            },
            summaries: {
                footer: function mppFooter() {
                    return <b style={{display:'flex',alignItems:'center'}}>Total</b>
                }
            }
        }, {
            header: 'Qty',
            accessor: 'campaignComponent.qty',
            dataType: 'number',
            readOnly: () => {
                return isReadOnly(true);
            },
            summaries: {
                footer: function mppFooterQty({rows}) {
                    return rows.reduce((total, current) => {
                        return total + (parseInt(current.campaignComponent?.qty) || 0);
                    }, 0)
                }
            }
        }, {
            header: 'Total',
            accessor: 'total',
            dataType: 'currency',
            readOnly: true,
            currencyAccessor: 'campaignComponent.currency',
            options: {
                getValue: ({row}) => {
                    const value = Math.floor(row.campaignComponent?.qty * (parseInt(row.campaignComponent?.unit_value_local) / (row.campaignComponent?.price_divisor)));
                    return value;
                }
//            return variableCurrencyValue({value:value,currency:field.currency});
            },
            summaries: {
                footer: ({currency, rows}) => {
                    const value = rows.reduce((total,current)=> { return (total+Math.floor(current.campaignComponent?.qty*(parseInt(current.campaignComponent?.unit_value_local)/(current.campaignComponent?.price_divisor)))); },0);
                    //return value;
                    return variableCurrencyValue({value:value,currency:currency});
//                    return 0;
                }
            }
        }, {
            header: 'Total Quote',
            accessor: 'total_quote',
            dataType: 'currency',
            readOnly: true,
            hideWhen: ({exchangeRateContext}) => {
                if (exchangeRateContext.options && exchangeRateContext.options.length > 1) return false;
                return true;
            },
            options: {
                // eslint-disable-next-line react/prop-types, react/display-name
                getValue: ({row, calcExchangeRate}) => {
                    return calcExchangeRate(row.campaignComponent?.currency, row.campaignComponent?.qty * row.campaignComponent?.unit_value_local/row.campaignComponent?.price_divisor);
//                return variableCurrencyValue({ currency: field.currency, value: calcExchangeRate(row.campaignComponent?.currency,row.campaignComponent?.qty * row.campaignComponent?.unit_value_local) });
                },
            },
            summaries: {
                footer: ({rows, currency, calcExchangeRate}) => {
                    const value = rows.reduce((total, current) => {
                        return (total + calcExchangeRate(current.campaignComponent?.currency, (parseInt(current.campaignComponent?.qty) * parseInt(current.campaignComponent?.unit_value_local) / parseInt(current.campaignComponent.price_divisor))));
                    }, 0);
                    return variableCurrencyValue({currency: currency, value: value,places:2});
                }
            }
        }, {
            header: 'Notes',
            accessor: 'notes',
            width: 'full',
            dataType: 'text'
//        editor: function notesEdit({field}) { return <InputGroup {...field} autoFocus={true} />; }
        }
    ];

    useEffect(() => {
        setTab('media-productions');
    }, []);
    const allowAddDelete = !(readOnly || isReadOnly(true));

    return <FieldTable
        newRow={newRow}
        newRowLabel={allowAddDelete ? "Add Media production" : null}
        columns={columns}
        values={values.mediaProductions}
        setValue={setValue}
        loading={loading}
        errors={errors}
        hasDelete={allowAddDelete}
        name="mediaProductions"
        className="campaigns__media-productions"
        summaries={summaries}
        readOnly={readOnly}
    />;
};

export default MediaProductionPane;
